import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Loading from "./components/Loading";

//页面
const N404 = lazy (() => import("./pages/404/404"));//404
const pages = [
  {
    path: "/home",
    component: lazy (() => import("./pages/Home/index")),//首页
  },
  {
    path: "/record",
    component: lazy (() => import("./pages/AddRecord/index")),//查看数据
  },
  {
    path: "/manual",
    component: lazy (() => import("./pages/Manual/index")),//手记数据
  },
  {
    path: "/all",
    component: lazy (() => import("./pages/ViewAllData/index")),//查看全部数据
  },
  {
    path: "/chinese-medicine_report",
    component: lazy (() => import("./pages/ChineseMedicine/index"))//中医
  },
  {
    path: "/western-medicine_report",
    component: lazy (() => import("./pages/WesternMedicine/index"))//西医
  },
  {
    path: "/vision-test",
    component: lazy (() => import("./pages/VisionTest/index"))//视力健康
  },
  {
    path: "/test-vision",
    component: lazy (() => import("./pages/TestVision/index"))//视力测试
  },
  {
    path: "/test-presbyopia",
    component: lazy (() => import("./pages/TestPresbyopia/index"))//老花测试
  },
  {
    path: "/test-color-blindness",
    component: lazy (() => import("./pages/TestColorBlindness/index"))//色盲测试
  },
  {
    path: "/eye-diseases",
    component: lazy (() => import("./pages/EyeDiseases/index"))//眼部问题
  },
  {
    path: "/all-vision-data",
    component: lazy (() => import("./pages/AllVisionData/index"))//眼部问题所有数据列表
  },
  {
    path: "/family-healthy-history",
    component: lazy (() => import("./pages/FamilyHealthyHistory/index"))//家族健康史
  },
  {
    path: "/history",
    component: lazy (() => import("./pages/DiseasesHistory/index"))//疾病史
  },
  {
    path: "/allergic-history",
    component: lazy (() => import("./pages/AllergicHistory/index"))//过敏史
  },
  {
    path: "/surgery-history",
    component: lazy (() => import("./pages/SurgeryHistory/index"))//手术史
  },
  {
    path: "/smoke-drink-healthy-history",
    component: lazy (() => import("./pages/OtherHealthyHistory/index"))//烟酒史
  },
  {
    path: "/share",
    component: lazy (() => import("./pages/Share/index"))//分享
  },
  {
    path: "/up-data-west-rep",
    component: lazy (() => import("./pages/UpDataWesterMedicineReport/index"))//上传报告
  },
];

//路由组件
const Routes = () => <Router>
  <Suspense fallback={<Loading always={true}/>}>
    <Switch>
      {pages.map ((item, index) =>
        <Route
          exact
          path={`${item.path}`}
          component={item.component}
          key={index}
        />)}
      <Redirect exact from="/" to="/home"/>
      <Route path="/*" component={N404}/>
    </Switch>
  </Suspense>
  <Loading/>
</Router>;
export default Routes;
